import React = require("react");
import { truncate } from 'lodash';

export interface ICardTitleProps {
    title: string;
    icon: string;
    maxLength: number;
}

export const CardTitle = (props: ICardTitleProps): React.ReactElement<ICardTitleProps> => {
    const truncatedTitle = truncate(props.title, { length: props.maxLength });
    return (
        <div className="wpo ui content header">
            <i className={`wpo ui left floating aw-icon ${props.icon}`}></i>
            <h4>{truncatedTitle}</h4>
        </div>
    );
}